import React from "react"
import Footer from "../Footer"
import MainServices from "../Main/MainServices"
import { Fade } from "@mui/material"
import timeout from "../../data/timeout"
import { logMessage } from "../../utils/utils"

const Services = () => {
  const scrollUp = () => {
    window.scrollTo({ top: 0, behavior: "smooth" })
  }
  setTimeout(() => {
    scrollUp()
  }, 100)
  return (
    <Fade timeout={timeout} in>
      <div className="pt-24 flex flex-col justify-between min-h-screen">
        <div className="text-3xl mb-10 text-[#002998ef]">Послуги:</div>
        <div className="grow mb-36">
          <MainServices />
        </div>

        {/* <div className="mt-16">
          <Footer language={language} />
        </div> */}
      </div>
    </Fade>
  )
}

export default Services
